import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Sparkles, ChevronRight, Download } from 'lucide-react';
import { featurePages } from '../data/knowledgeHub';

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.typeit4u.keyboard";

const FeatureLanding = () => {
  const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-orange-50 via-white to-pink-50">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springConfig}
            className="max-w-3xl mx-auto text-center"
          >
            <Sparkles className="w-16 h-16 mx-auto mb-6" style={{ color: '#FF6B9D' }} />
            <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ color: '#0A0A0A' }}>
              TypeIt4U Features
            </h1>
            <p className="text-base sm:text-lg text-gray-600 mb-8">
              Discover every powerful feature that makes TypeIt4U India's smartest keyboard
            </p>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2"
              style={{
                background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B9D 100%)',
                color: 'white',
                borderRadius: '26px',
                padding: '16px 32px',
                fontSize: '16px',
                fontWeight: 500
              }}
            >
              <Download className="w-5 h-5" />
              Download Free
            </a>
          </motion.div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-16 bg-white">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {featurePages.map((feature, index) => (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ ...springConfig, delay: index * 0.05 }}
              >
                <Link
                  to={`/feature/${feature.slug}`}
                  className="block bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-xl hover:border-orange-200 transition-all h-full"
                >
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                    style={{
                      background: 'linear-gradient(135deg, rgba(255, 140, 66, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%)'
                    }}
                  >
                    <Sparkles className="w-6 h-6" style={{ color: '#FF6B9D' }} />
                  </div>
                  <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A0A0A' }}>
                    {feature.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                    {feature.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm text-orange-600 font-medium">
                    Learn more <ChevronRight className="w-4 h-4" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-br from-orange-50 to-pink-50">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={springConfig}
            className="max-w-2xl mx-auto text-center"
          >
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#0A0A0A' }}>
              Ready to Experience All Features?
            </h3>
            <p className="text-gray-600 mb-6">
              Download TypeIt4U and unlock India's most powerful AI keyboard.
            </p>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2"
              style={{
                background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B9D 100%)',
                color: 'white',
                borderRadius: '26px',
                padding: '16px 32px',
                fontSize: '16px',
                fontWeight: 500
              }}
            >
              <Download className="w-5 h-5" />
              Download on Play Store
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FeatureLanding;
